module.exports = __webpack_public_path__ + "img/SketchPngbdc51b3677cf356afc464d8db891780e3325af128c784e53f75d7c45ed5034f4.7f973a39.png";